import React from "react";
import ModalComponent from "../Modals";
import { Box, Typography, Button, Divider, Alert } from "@mui/material";
import { useMediaQuery, useTheme } from "@mui/material";
import { handleCopyToClipboard } from "../../utils/copyToClipboard";
import { getOrCreateAnonId } from "../../utils/getOrCreateAnonId";
import { useParams } from "react-router-dom";
import { trackEvent } from "../../utils/analytics";

const guideList = (id: string) => {
	return [
		{
			url: "https://storage.googleapis.com/public_viteslink_storage/images/IOSGuide/guide1-min.webp",
			Component: () => {
				return (
					<Box display={"flex"} justifyContent={"center"}>
						<Typography textAlign={"center"}>
							Open
							<a href={window.location.origin} target={"_blank"} style={{ textDecoration: "none", margin: "0 5px" }}>
								{window.location.origin}
							</a>
							on Safari & Click on Share Icon
						</Typography>
					</Box>
				);
			}
		},
		{
			url: "https://storage.googleapis.com/public_viteslink_storage/images/IOSGuide/guide2-min.webp",
			title: "Add Viteslink to your home screen"
		},
		{
			url: "https://storage.googleapis.com/public_viteslink_storage/images/IOSGuide/guide3-min.webp",
			title: "Click Add"
		},
		{
			Component: () => (
				<Alert severity="info">
					Keep the Viteslink app on your home screen to receive notifications. You only need to add it once.
				</Alert>
			),
			title: ""
		},
		{
			url: "https://storage.googleapis.com/public_viteslink_storage/images/IOSGuide/guide6-min.webp",
			title: "Open App from your home screen"
		},
		{
			Component: () => {
				return (
					<Box>
						<Button
							variant={"contained"}
							onClick={() => {
								trackEvent("notifications_auth_url_owner", {
									scope: "notifications",
									description: "copy owner auth url"
								});
								const token = localStorage.getItem("token");
								const anonymous_token = getOrCreateAnonId(id || "");
								const search = window.location.search;
								let tokenQuery = search ? "&token=" + token : "?token=" + token;
								tokenQuery = tokenQuery + "&anonymous_token=" + anonymous_token;
								handleCopyToClipboard(`${window.location.pathname + search + tokenQuery}`);
							}}
						>
							Authenticated Url
						</Button>
					</Box>
				);
			},
			title: "Click Copy Authenticated Url"
		},
		{
			url: "https://storage.googleapis.com/public_viteslink_storage/images/IOSGuide/guide7-minn.webp",
			title: "Click on the navigation icon, paste your authenticated url and hit Navigate"
		},
		{
			url: "https://storage.googleapis.com/public_viteslink_storage/images/IOSGuide/guide4-min.webp",
			title: "Go to Settings then notification settings"
		},
		{
			url: "https://storage.googleapis.com/public_viteslink_storage/images/IOSGuide/guide5-minn.webp",
			title: "Enable notifications"
		}
	];
};
const guestGuideList = (id: string) => {
	return [
		{
			url: "https://storage.googleapis.com/public_viteslink_storage/images/IOSGuide/guide1-min.webp",
			Component: () => {
				return (
					<Box display={"flex"} justifyContent={"center"}>
						<Typography textAlign={"center"}>
							Open
							<a href={window.location.origin} target={"_blank"} style={{ textDecoration: "none", margin: "0 5px" }}>
								{window.location.origin}
							</a>
							on Safari & Click on Share Icon
						</Typography>
					</Box>
				);
			}
		},
		{
			url: "https://storage.googleapis.com/public_viteslink_storage/images/IOSGuide/guide2-min.webp",
			title: "Add Viteslink to your home screen"
		},
		{
			url: "https://storage.googleapis.com/public_viteslink_storage/images/IOSGuide/guide3-min.webp",
			title: "Click Add"
		},
		{
			Component: () => (
				<Alert severity="info">
					Keep the Viteslink app on your home screen to receive notifications. You only need to add it once.
				</Alert>
			),
			title: ""
		},
		{
			url: "https://storage.googleapis.com/public_viteslink_storage/images/IOSGuide/guide6-min.webp",
			title: "Open App from your home screen"
		},
		{
			Component: () => {
				return (
					<Box>
						<Button
							variant={"contained"}
							onClick={() => {
								trackEvent("notifications_auth_url_guest", {
									scope: "notifications",
									description: "copy guest auth url"
								});
								const anonymous_token = getOrCreateAnonId(id || "");
								const search = window.location.search;
								const tokenQuery = search
									? "&anonymous_token=" + anonymous_token
									: "?anonymous_token=" + anonymous_token;
								handleCopyToClipboard(`${window.location.pathname + search + tokenQuery}`);
							}}
						>
							Authenticated Url
						</Button>
					</Box>
				);
			},
			title: "Click Copy Authenticated Url"
		},
		{
			url: "https://storage.googleapis.com/public_viteslink_storage/images/IOSGuide/guide7-minn.webp",
			title: "Click on the navigation icon, paste your authenticated url and hit Navigate"
		},
		{
			url: "https://storage.googleapis.com/public_viteslink_storage/images/IOSGuide/guide8-min.webp",
			title: "Click notification icon"
		},
		{
			url: "https://storage.googleapis.com/public_viteslink_storage/images/IOSGuide/guide5-minn.webp",
			title: "Enable notifications"
		}
	];
};

const locationGuideList: () => { url?: string; Component?: () => React.ReactNode; title: string }[] = () => {
	return [
		{
			url: "https://storage.googleapis.com/public_viteslink_storage/images/location/step1-min.webp",
			title: "Open google maps app from your device"
		},
		{
			url: "https://storage.googleapis.com/public_viteslink_storage/images/location/step2-min.webp",
			title: "Search and Select your wedding Location then Click Share button"
		},
		{
			url: "https://storage.googleapis.com/public_viteslink_storage/images/location/step3-min.webp",
			title: "Click Copy"
		}
	];
};

const FeatureGuide = ({ title, onClose, type }: { title: string; onClose: () => void; type: string }) => {
	const theme = useTheme();
	const params = useParams();
	const id = params.id;
	const isSmallerScreen = useMediaQuery(theme.breakpoints.down("md"));
	const list = () => {
		switch (type) {
			case "Guest":
				return guestGuideList(id || "");
			case "Owner":
				return guideList(id || "");
			case "Location":
				return locationGuideList();
			default:
				return [];
		}
	};

	return (
		<ModalComponent
			open={true}
			handleCloseModal={onClose}
			width={isSmallerScreen ? "95%" : "450px"}
			isSmallerScreen={isSmallerScreen}
		>
			<Box mt={1} mb={2}>
				<Typography className={"title"}>{title}</Typography>
			</Box>
			<Box
				mt={2}
				display={"flex"}
				justifyContent={"center"}
				flexWrap={"wrap"}
				gap={2}
				overflow={"auto"}
				maxHeight={500}
				style={{ background: "#fafafa", padding: "10px 0" }}
			>
				{list().map((item, i) => (
					<Box
						key={`guide-${i}`}
						display={"flex"}
						flexDirection={"column"}
						alignItems={"center"}
						minHeight={item.Component ? "unset" : 400}
						width={"100%"}
						gap={2}
					>
						{item.url && <img height={400} src={item.url} alt={`guide ${i + 1}`} />}
						{item.Component && item.Component()}
						<Typography style={{ textAlign: "center", maxWidth: "90%" }}>{item.title}</Typography>
						{i < list().length - 1 && (
							<Box width={"100%"} my={2}>
								<Divider style={{ height: "1px", backgroundColor: "#d2d2d2" }} />
							</Box>
						)}
					</Box>
				))}
			</Box>
		</ModalComponent>
	);
};

export default FeatureGuide;
